export const themesMockData = [
  {
    id: 1,
    title: 'آسمان',
    image: '/assets/images/themes/Home1.jpg',
    value: 1,
  },
  {
    id: 2,
    title: 'برنا',
    image: '/assets/images/themes/Home2.jpg',
    value: 2,
  },
  {
    id: 3,
    title: 'امید',
    image: '/assets/images/themes/Home3.jpg',
    value: 3,
  },
  {
    id: 4,
    title: 'دریا',
    image: '/assets/images/themes/Home4.jpg',
    value: 4,
  },
  {
    id: 5,
    title: 'برکه',
    image: '/assets/images/themes/Home5.jpg',
    value: 5,
  },
  {
    id: 6,
    title: 'ترنج',
    image: '/assets/images/themes/Home6.jpg',
    value: 6,
  },
  {
    id: 7,
    title: 'لیمو',
    image: '/assets/images/themes/Home7.jpg',
    value: 7,
  },
  {
    id: 8,
    title: 'ثریا',
    image: '/assets/images/themes/Home8.jpg',
    value: 8,
  },
  {
    id: 9,
    title: 'ماهور',
    image: '/assets/images/themes/Home9.jpg',
    value: 9,
  },
];

export const CVThemesMockData = [
  {
    id: 1,
    title: 'رایکا',
    image: '/assets/images/themes/CV1.jpg',
    value: 1,
  },
  {
    id: 2,
    title: 'آتوسا',
    image: '/assets/images/themes/CV2.jpg',
    value: 2,
  },
  {
    id: 3,
    title: 'ويدا',
    image: '/assets/images/themes/CV3.jpg',
    value: 3,
  },
];
